module.exports = __webpack_public_path__ + "static/img/icon_success.9545a4e2.png";